// extracted by mini-css-extract-plugin
module.exports = {"highlight":"ActiveTableCell_highlight__3w25e"};